import {  
  MethodsFastReport,
    MethodsStrGet,
    MethodsStrSingleGet,
    MethodsStrSabitGet,
    MethodsStrFilterGet,
    MethodsStrFileGet,
    MethodsStrPost,
    MethodsStrPut,
    MethodsStrDelete, 
    MethodsStrAllPut,
    GenericComputed 
    } from "@/state/helpers";

    import moment from "moment"; 

const Sabit = {
    data() {
      return { 

      }
    },
    methods: {
    ...MethodsFastReport,
    ...MethodsStrGet,
    ...MethodsStrSingleGet,
    ...MethodsStrSabitGet,
    ...MethodsStrFilterGet,
    ...MethodsStrFileGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrAllPut,
    ...MethodsStrDelete, 
                ChangePage(DefaultPage) {
                    if(DefaultPage){ 
                        this.Page.PageNumber = DefaultPage
                        this.Get(); 
                    }
                },
                ExcelExport(table, name) {
                  let uri= "data:application/vnd.ms-excel;base64,"
                  let template=
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta http-equiv="content-type" content="text/plain; charset="utf-8"></head><body><table>{table}</table></body></html>'
                  let base64= function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                  }
                  let format= function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                      return c[p];
                    });
                  }
                  if (!table.nodeType) table = this.$refs.ExcelExportTable;
                  var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
                  var a = document.createElement('a');
                   a.href = uri +base64(format(template, ctx));
                    a.download = name + '.xls';
                    a.click(); 
                },
                Export2Word(element, filename){
                  var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
                  var postHtml = "</body></html>";
                  var html = preHtml+document.getElementById(element).innerHTML+postHtml; 
                  var blob = new Blob(['\ufeff', html], {
                      type: 'application/msword'
                  }); 
                  var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
                  filename = filename?filename+'.doc':'document.doc'; 
                  var downloadLink = document.createElement("a"); 
                  document.body.appendChild(downloadLink);  
                  if(navigator.msSaveOrOpenBlob ){
                      navigator.msSaveOrOpenBlob(blob, filename);
                  }else{ 
                      downloadLink.href = url; 
                      downloadLink.download = filename; 
                      downloadLink.click();
                  } 
                  document.body.removeChild(downloadLink);
                 }, 
                RolesControl(KullaniciRolleri,Rol){ 
                  let YetkiSorgu = KullaniciRolleri.filter((item) =>
                  item.includes(Rol)
                  );
                  if (YetkiSorgu.length != 0) return true; 
                  else  return false;  
                },
              
               
    },
    computed: {
      ...GenericComputed 
    }, 
    created(){   
        this.Get();    
    }, 
    mounted() {
      setTimeout(() => {
        this.showModal = true;
      }, 1500);
    }, 
    filters: {
      formatNoktaToVirgul(value) {
        if (value) { 
          return  value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        else{
          return value;
        }
      },
      formatDate(value) {
        if (value) {
          return moment(String(value)).format("YYYY-MM-DD");
        }
      },
      formatDateOnlyYear(value) {
        if (value) {
          return moment(String(value)).format("YYYY");
        }
      },
      formatDateTable(value) {
        if (value) {
          return moment(String(value)).format("DD.MM.YYYY");
        }
      },
      TrParaFormat(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") 
      },
    },
     
  }

 
 
  export default Sabit
